import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useMemo,
} from 'react'
import { isArray, pick, assignIn } from 'lodash-es'
import { createStore, useStore } from 'zustand'

import shallow from 'zustand/shallow'

import { getQuery } from '@vt/utils'
// import deepExtend from 'deep-extend'
import dotObjectExpander from '@thefoot/dot-object-expander'
import { useViewConfigSWR } from '../../swrs/tables/use-view-config-swr'
import createTbViewStore from './create-tbview-store'
import { useAppStore } from '../../apps/app-store-provider'
import useProjectStore from '../../project/use-project-store'

const Context = createContext()

// export const useTbViewStore = useStore

export const useTbViewStore = (selectors, equalityFn = shallow) => {
  const store = useContext(Context)
  if (store === null) {
    throw new Error('no provider')
  }
  // if (isArray(selectors)) {
  //   const selectedVals = {}
  //   for (let index = 0; index < selectors.length; index++) {
  //     const element = selectors[index]
  //     selectedVals[element] = useStore(store, (x) => x[element], equalityFn)
  //   }
  //   return selectedVals
  // }
  if (isArray(selectors)) {
    return useStore(store, (x) => pick(x, selectors), equalityFn)
  }
  return useStore(store, selectors, equalityFn)
}

const Wrapper = ({
  viewConfig,
  ditto,
  extendsStore,
  initedStoreByViewConfig,
  userInfoInApp,
  vtProject,
  children,
}) => {
  const store = useMemo(
    () =>
      createStore(
        createTbViewStore(
          ditto,
          viewConfig,
          extendsStore,
          {
            initedStoreByViewConfig,
          },
          userInfoInApp,
          vtProject
        )
      ),
    [viewConfig]
  )
  return <Context.Provider value={store}>{children}</Context.Provider>
}

export const TbViewProvider = ({ children, vid, tbId, extendsStore }) => {
  const { appId, tbs, getDitto, userInfoInApp } = useAppStore((x) =>
    pick(x, ['appId', 'tbs', 'getDitto', 'userInfoInApp'])
  )
  const { getVtProject } = useProjectStore((state) =>
    pick(state, ['getVtProject'])
  )
  const vtProject = getVtProject()
  const [initedStore, setInitedStore] = useState()

  // 判断是否是回收站
  const { type, isRecycle, ...others } = getQuery()
  const ditto = getDitto(tbId)

  // 临时添加
  const currentTbSlug = ((tbs && tbs[tbId]) || {}).tbSlug
  const { viewConfig } = useViewConfigSWR(
    appId,
    ditto.tbId || tbId,
    vid,
    {
      isRecycle: isRecycle || type === 'recycle',
    },
    currentTbSlug,
    userInfoInApp
  )

  // 判断url的参数中是否有v.开头的参数，如果有则添加到viewconfig中
  let hasCustomConfig = false

  if (document.location && document.location.search) {
    const searchParams = document.location.search
    hasCustomConfig = searchParams.indexOf('.') !== -1
  }

  if (hasCustomConfig) {
    const configKey = Object.keys(others).filter(
      (key) => key.indexOf('.') !== -1
    )[0]

    // TODO:还有一种v-tbid的情况

    const newConfig = dotObjectExpander({
      [configKey]: others[configKey],
    })
    if (viewConfig) {
      assignIn(viewConfig, newConfig.v)
    }
  }

  const initedStoreByViewConfig = () => {
    if (viewConfig) {
      setInitedStore(false)
      setTimeout(() => {
        setInitedStore(true)
      }, 10)
    }
  }

  useEffect(() => {
    initedStoreByViewConfig()
  }, [viewConfig])

  if (!initedStore) {
    return null
  }

  if (viewConfig) {
    return (
      <Wrapper
        viewConfig={viewConfig}
        ditto={ditto}
        extendsStore={extendsStore}
        initedStoreByViewConfig={initedStoreByViewConfig}
        userInfoInApp={userInfoInApp}
        vtProject={vtProject}
      >
        {children}
      </Wrapper>
    )
  }

  return null

  // console.log('[1]', viewConfig)
  // const createStore = () => create(setInitedStore)
  //   const createStore = () =>
  //     create(
  //       createTbViewStore(ditto, viewConfig, extendsStore, {
  //         initedStoreByViewConfig,
  //       })
  //     )
  //   return <Provider createStore={createStore}>{children}</Provider>
}
